/* ==========================================================================
   Cybercraft — header logo playback nudge

   Muted autoplay is permitted by every current browser, so the autoplay
   attribute usually suffices. It does NOT suffice in a few real cases:

     • iOS Low Power Mode blocks autoplay outright, muted or not
     • Some data-saver modes block it
     • Browsers suspend media in background tabs and do not always resume it
       when the tab is brought forward

   Because this sits in the header of every page, a logo frozen on its first
   frame is a visible defect rather than a cosmetic one. This retries play()
   when the tab becomes visible and once on first interaction.

   play() returns a promise that rejects when blocked. That rejection is
   swallowed deliberately — the static frame is an acceptable fallback and an
   unhandled rejection would show up as a console error on every page.
   ========================================================================== */

(function () {
  var video = document.querySelector('.header-logo__video');
  if (!video) return;

  function attempt() {
    if (!video.paused) return;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  attempt();

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) attempt();
  });

  ['pointerdown', 'keydown', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, attempt, { once: true, passive: true });
  });
})();
